module.exports = __webpack_public_path__ + "img/bitbucket.c271e9cb.png";